module.exports = __webpack_public_path__ + "img/painel.0369eb30.png";